import { localize } from '@/helpers/localize'
import { resolveLinkLocale, resolveLineBreakOfLastWord } from '@/helpers/string'

const toSnakeCase = v => v.replace(/\W/g, '_').toLowerCase()
const resolveLineBreakAndLocalizeValue = v => resolveLineBreakOfLastWord(localize(v))

const formatters = {
  identifier: toSnakeCase,
  header: v => resolveLineBreakAndLocalizeValue(v),
  headerSingle: v => resolveLineBreakAndLocalizeValue(v),
  headerPlural: v => resolveLineBreakAndLocalizeValue(v),
  subheader: v => resolveLineBreakAndLocalizeValue(v),
  subheaderSingle: v => resolveLineBreakAndLocalizeValue(v),
  subheaderPlural: v => resolveLineBreakAndLocalizeValue(v),
  success: v => resolveLineBreakAndLocalizeValue(v),
  error: v => resolveLineBreakAndLocalizeValue(v),
  inputPlaceholder: v => localize(v),
  newsletterSignup: v => localize(v),

  buttons(buttons, state) {
    buttons.forEach(button => {
      button.text = localize(button.text)
      if (button.link) button.link = resolveLinkLocale(button.link)

      if (button.shouldCloseOnClick) {
        const onclick = button.onclick || function () {}
        button.onclick = () => {
          onclick()
          state.closeOverlay()
        }
      }
    })
    return buttons
  },

  heroImages(images) {
    return images.filter(image => image && /\S/.test(image))
  },
}
const getDefaultState = () => {
  return {
    identifier: 'global',
    header: '',
    headerSingle: '',
    headerPlural: '',
    subheader: '',
    subheaderSingle: '',
    subheaderPlural: '',
    success: '',
    error: '',
    inputPlaceholder: '',
    newsletterSignup: '',
    buttons: [],
    heroImages: [],
    heroImagePosition: On.Popup ? On.Popup.defaultHeroImagePosition : '',
    cookieLifetime: null,
    variant: On.Popup ? On.Popup.defaultVariant : '',
    theme: On.Popup ? On.Popup.defaultTheme : '',
    closeBtnColorIfOnImg: '',
    childComponentPath: '',
    isVisible: false,
    closeOverlay: null,
    initializedAt: 0,
    initDelay: 0,
    campaignMonitorListId: '',
    isImpossibleToClose: false,
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),

  mutations: {
    setState(state, payload) {
      for (const key in payload) state[key] = payload[key]
    },

    setInitialState(state, payload) {
      const defaultState = getDefaultState()
      const newState = { ...defaultState, ...payload }
      for (const key in newState) {
        state[key] = formatters[key] ? formatters[key](newState[key], state) : newState[key]
      }
    },
  },

  getters: {
    identifier: state => state.identifier,
    header: state => state.header,
    headerSingular: state => state.headerSingle,
    headerPlural: state => state.headerPlural,
    subheader: state => state.subheader,
    subheaderSingular: state => state.subheaderSingle,
    subheaderPlural: state => state.subheaderPlural,
    success: state => state.success,
    error: state => state.error,
    inputPlaceholder: state => state.inputPlaceholder,
    newsletterSignup: state => state.newsletterSignup,
    buttons: state => state.buttons,
    heroImages: state => state.heroImages,
    heroImagePosition: state => state.heroImagePosition,
    cookieLifetime: state => state.cookieLifetime,
    variant: state => state.variant,
    theme: state => state.theme,
    closeBtnColorIfOnImg: state => state.closeBtnColorIfOnImg,
    childComponentPath: state => state.childComponentPath,
    isVisible: state => state.isVisible,
    closeOverlay: state => state.closeOverlay,
    initializedAt: state => state.initializedAt,
    initDelay: state => state.initDelay,
  },
}
